export default __webpack_public_path__ + "static/media/Mark-4-Suit-07.5c281828.jpg";